import createSvgIcon from '@mui/material/utils/createSvgIcon.js';
import React from 'react';

export default createSvgIcon(
  <path d="M10.4444 19.8765q2.6667-.0494 4.4445-1.8271 1.7778-1.7778 1.8765-4.4938h2.0741q-.0494 3.6048-2.4444 5.9753T10.4444 22q-3.6048-.0987-5.9753-2.4691Q2.0988 17.1605 2 13.5556 2.0987 10 4.4691 7.6049q2.3704-2.395 5.9753-2.4444v2.074q-2.716.0989-4.4938 1.8766t-1.8271 4.4445q.0494 2.716 1.8271 4.4938 1.7778 1.7778 4.4938 1.8271m8.3951-14.716H22v2.074h-3.1605v3.1606h-2.074V7.2346h-3.1606V5.1605h3.1605V2h2.0741z" />,
  'CirclePlus',
);
